import React from 'react'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="#202020"
        fillOpacity="0.5"
        d="M15.334 8h3.333v1.333h-1.333V18a.667.667 0 01-.667.667H7.334A.666.666 0 016.667 18V9.333H5.334V8h3.333V6a.667.667 0 01.667-.667h5.333a.667.667 0 01.667.667v2zm.667 1.333H8v8h8v-8zm-6 2h1.333v4h-1.333v-4zm2.666 0h1.334v4h-1.334v-4zm-2.666-4.666V8h4V6.667h-4z"
      ></path>
    </svg>
  )
}

export default Icon
